import { TODAY } from '../../constants';
import { edgeFunctionData } from '../../services/edgeFunctionData';
import { upsertJiraConsumption } from '../../services/jiraConsumption';
import { runJiraSync } from '../../services/jiraSync';
import { saveJiraSyncConfig } from '../../services/jiraSyncConfig';
import { notify } from '../../store/feedback';
import { isoStr } from '../../utils/dates';
import { jiraProjectKeys } from '../../utils/jira';
import { syncAllProjects } from './fullSync';
import { consumptionRows, epicKeys, jiraSyncConfigMaps } from './syncMaps';

export default function jiraSyncHandlers(deps, api) {
  const { adminUsers, setJiraData, setYearImportModal, appState, syncYear } = deps;

  // Synchro complète manuelle : importe les feuilles d'heures de tout le monde,
  // tous les mois depuis la première phase jusqu'au mois en cours, puis recalcule
  // les heures consommées (épics + projets).
  async function handleFullJiraSync() {
    const allProjectKeys = jiraProjectKeys(appState.clients);
    if (!allProjectKeys.length) return notify("Aucun projet client n'a de clé Jira configurée.");
    // Plage de mois : année sélectionnée, jusqu'au mois courant si c'est l'année en cours
    const currentYM = isoStr(TODAY).slice(0, 7);
    const toMonth = `${syncYear}-12` > currentYM ? currentYM : `${syncYear}-12`;
    const totals = await syncAllProjects({
      projectKeys: allProjectKeys,
      fromMonth: `${syncYear}-01`,
      toMonth,
      clients: appState.clients,
      adminUsers,
      setYearImportModal,
    });
    // Recalcule les heures consommées (épics + projets) affichées sur les cartes
    await handleSyncJira();
    api.loadHoursByBrick();
    setYearImportModal({ result: true, ...totals });
  }

  async function syncJiraConfig(clients) {
    const { epic_map, default_brique_map } = jiraSyncConfigMaps(clients);
    await saveJiraSyncConfig(default_brique_map, epic_map, jiraProjectKeys(clients));
  }

  async function handleSyncJira() {
    setJiraData((d) => ({ ...d, loading: true, error: null }));
    try {
      const data = await edgeFunctionData(
        await runJiraSync(epicKeys(appState.clients), jiraProjectKeys(appState.clients)),
      );
      console.log('[Jira sync] byProject:', JSON.stringify(data.byProject));
      console.log('[Jira sync] byProjectMonth:', JSON.stringify(data.byProjectMonth));
      const byEpic = data.byEpic || {},
        byProject = data.byProject || {},
        byProjectMonth = data.byProjectMonth || {},
        byProjectDay = data.byProjectDay || {};
      // Persiste en base pour que la donnée survive aux rechargements de page
      const now = new Date().toISOString();
      const rows = consumptionRows({ byEpic, byProject, byProjectMonth, byProjectDay }, now);
      if (rows.length) {
        const { error: upErr } = await upsertJiraConsumption(rows);
        if (upErr)
          throw new Error("Synchro Jira OK mais échec d'enregistrement : " + upErr.message);
      }
      setJiraData({
        byEpic,
        byProject,
        byProjectMonth,
        byProjectDay,
        loading: false,
        error: null,
        lastSync: new Date(now),
      });
      syncJiraConfig(appState.clients);
    } catch (e) {
      setJiraData((d) => ({ ...d, loading: false, error: e.message || 'Erreur Jira' }));
    }
  }

  return {
    handleFullJiraSync,
    syncJiraConfig,
    handleSyncJira,
  };
}
